'use strict';

var util = require('./util'),
	dialog = require('./dialog');

var sizeChart = {
	init: function() {
		$("body").off('click', '.size-chart-link a, .catherines-size-chart-link a').on('click', '.size-chart-link a, .catherines-size-chart-link a', function(e) {
			e.preventDefault();
			var url = $(this).attr('href');
			url = util.appendParamToURL(url,'format','ajax');
	        $.ajax({
	        	url: url,
	        	success: function(data) {
	        		var sizeChartDialog = dialog.create({
	        			target: '#sizechart-container',
	        			options: {
			            	dialogClass: 'sizechart-dialog',
			            	autoOpen: false,
			            	modal: true,
			            	title: 'sizechart-dialog',
			            	open: function() {
			            		/* WCAG_Modal_focus_management */
			            		$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
			                    	$(this).focus();
			                    });
			                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
			                    
			        	        if($('.ui-dialog.quick-view').length > 0) {
			        	        	$('.zoomContainer').removeClass('js-zoom-container');
			        	        	$('.zoomWindowContainer').addClass('hide');
			        	        }
			        	        $('.ui-widget-overlay').on('click',function(e){
			                		if($('.sizechart-dialog').is(':visible')) {
			                			$('.sizechart-dialog').find('.ui-dialog-titlebar-close').trigger('click');
			                		}
			                	});
			            	},
			            	close: function() {
			            		if($('.ui-dialog.quick-view').length > 0) {
			        	        	$('.zoomContainer').addClass('js-zoom-container');
			        	        	$('.zoomWindowContainer').removeClass('hide');
			        	        }
				            }
			            }
					});
					$(sizeChartDialog).children().remove();
					$(sizeChartDialog).append(data);
					sizeChartDialog.dialog("open");
					sizeChart.populateSizeGuideJSMenu();
	        	}
	        });
	    });
		$('body').on('click', '.size-chart-navigation', function(e) {
			e.preventDefault();
			var url = $(this).attr('href');
			url = util.appendParamToURL(url,'format','ajax');
			   $.ajax({
		            url: url,
		            success:function(response) {
		            	$('.size-guide-content').html($(response).find('.size-guide-content').html());
		            	$('.size-guide-content').addClass('active-menu');
		            	if($(window).width() < 768) {
		            		$('.size-chart-data, .brand-dropdown, .size-guide-navigation__dropdown_selected').show("slide", {
			                    direction: "right"
			                }, 400);
		            		$('.size-guide-navigation__dropdown_selected .selected-category').html( $('.size-guide-navigation a.selected').text() );
		            	}
						sizeChart.populateSizeGuideJSMenu();
						if(window.lastClickOrKey === 'key'){
							$('.size-chart-navigation.selected').focus().addClass('focus-outline');
						}
		            }
		        });			
		});
		// Initialize the size-guide / size-chart events
		$('body').on('change','.size-guide-select', function (e) {
			e.preventDefault();
			var url = $('.size-guide-select').val();
			url = util.appendParamToURL(url,'format','ajax');
			$.ajax({
				url: url,
				success: function(response) {
					$('.content-asset.size-chart-data').html($(response).find('.content-asset.size-chart-data').html());
					// IE11 fix for loosing focus from drop down
					var sizeSelect = $('.brand-dropdown_selectMenu select');
					if(sizeSelect.attr("data-tab") === "true"){
						sizeSelect.parent().addClass("focused");
						sizeSelect.removeAttr("data-tab").trigger("focus");
						setTimeout(function(){
							sizeSelect.addClass("focus-outline");
						}, 100);
					}
				}
			});
		});

		// Initialize the size-guide / size-chart navigation handlers
		$('body').on('click','.size-guide-navigation__dropdown_selected', function() {
			//$('.size-guide-navigation').toggleClass('active');
			$('.size-guide-navigation').show("slide", {
                direction: "left"
            }, 200);
			$('.size-chart-data, .brand-dropdown, .size-guide-navigation__dropdown_selected').removeAttr('style');
			$('.size-guide-content').removeClass('active-menu');
			if ($('.size-guide-navigation').is(':visible')) {
				$(this).find('.fa-angle-up').css('display','block');
				$(this).find('.fa-angle-down').css('display','none');
			} else {
				$(this).find('.fa-angle-up').css('display','none');
				$(this).find('.fa-angle-down').css('display','block');
			}
		});
	},
	/**
	 * @description Initialize product detail page with a JS size guide sub-menu.
	 */
	populateSizeGuideJSMenu: function() {
		var selectMenu = $('.brand-dropdown .size-guide-select');
		var JSMenu = $('.brand-dropdown .brand-dropdown_JSMenu .dropdown-options');
		var tempMenu = document.createElement('div');
		var JSMenuOptions = document.createDocumentFragment();
		var indexNum = 0;
		if(selectMenu.find('option').size() > 0) {
			selectMenu.find('option').each(function() {
				if ($(this).val() != '') {
	                if ($(this).is(":selected")) {
	                	$('.brand-dropdown .selected-option').text($(this).text());
	                	$('<div/>', {
	                		addClass: "item selected",
	                		value: $(this).val(),
	                		text: $(this).text(),
	                		indexValue: indexNum++
	                	}).appendTo(tempMenu);
	                }
	                else {
	                	$('<div/>', {
	                		addClass: "item",
	                		value: $(this).val(),
	                		text: $(this).text(),
	                		indexValue: indexNum++
	                	}).appendTo(tempMenu);
	                }
	            }
			});
			while ( tempMenu.firstChild ) { 
				JSMenuOptions.appendChild( tempMenu.firstChild ); 
			}
			JSMenu.append(JSMenuOptions);
			sizeChart.eventsSizeGuideJSMenu();
		}
	},
	eventsSizeGuideJSMenu: function() {
		$('.brand-dropdown_JSMenu').on('click', function() {
			$(this).toggleClass('is-active');  
			$(this).next('.brand-dropdown_selectMenu').find("select").removeAttr("data-tab");
		});
		$('.brand-dropdown_JSMenu').on('keyup', function() {
			$(this).next('.brand-dropdown_selectMenu').addClass("focused").find("select").addClass("focus-outline").trigger('focus');  
			setTimeout(function(thisRef){
				$(thisRef).removeClass("focus-outline");
			}, 100, this);
		});
		$('.brand-dropdown_selectMenu select').on("blur", function(){
			if($(this).parent().hasClass('focused')){
				$(this).attr("data-tab","true");
			}
			$(this).parent().removeClass('focused').prev().removeClass('focus-outline');						
		})
		$('.brand-dropdown_JSMenu .item').on('click', function() {
			var itemValue = $(this).attr('value');
			
			$('select.size-guide-select').find('option[value="'+itemValue+'"]').prop("selected", true);
			$('.size-guide-select').change();
		});
		$('.size-guide-select').on('change', function() {
			$('.brand-dropdown_JSMenu .selected-option').text($('.size-guide-select').find('option:selected').text());
		});
	}
}
module.exports = sizeChart;